import React, { FC, useEffect } from 'react'
import { XelaColor } from '@/XelaReact'
import { showNotification } from '@mantine/notifications'
import { IconAlertTriangle, IconCheck } from '@tabler/icons-react'
import { usePage } from '@inertiajs/react'

const Guest: FC<{ children: React.ReactNode; style?: React.CSSProperties; align?: string }> = ({
  children,
  style,
  align = 'center',
}) => {
  const flash = usePage().props.flash as Record<string, unknown>

  useEffect(() => {
    if (flash.message) {
      showNotification({
        withCloseButton: true,
        autoClose: 5000,
        title: 'Success',
        message: flash.message as string,
        color: 'green',
        icon: <IconCheck />,
      })
    }

    if (flash.error) {
      showNotification({
        withCloseButton: true,
        autoClose: 5000,
        title: 'Error',
        message: flash.error as string,
        color: 'red',
        icon: <IconAlertTriangle />,
      })
    }
  }, [flash.timestamp, flash.message, flash.error])

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: align === 'initial' ? 'initial' : 'center',
        justifyContent: align === 'initial' ? 'initial' : 'center',
        background: XelaColor.Gray12,
        ...style,
      }}
    >
      {children}
    </div>
  )
}

export default Guest
